import { buildProps } from '@zoryn/utils'

import type { ExtractPublicPropTypes, PropType } from 'vue'
import type { GridImportColumn, GridImportMode, ImportRowError } from './types'

export type GridImportValidateMeta = {
  sourceFileName?: string
}

export type GridImportServerValidateFn = (
  rows: Record<string, unknown>[],
  meta: GridImportValidateMeta
) => Promise<ImportRowError[] | void | null>

export const gridImportProps = buildProps({
  columns: {
    type: Array as PropType<GridImportColumn[]>,
    default: () => [],
  },
  importMode: {
    type: String as PropType<GridImportMode>,
    default: 'insertTop',
  },
  maxRows: {
    type: Number,
    default: 5000,
  },
  templateTitle: {
    type: String,
    default: '',
  },
  templateCode: {
    type: String,
    default: '',
  },
  sheetName: {
    type: String,
    default: '',
  },
  loading: Boolean,
  /** 是否在前端校验必填等规则，默认关闭，由 serverValidate / 后端处理 */
  clientValidate: {
    type: Boolean,
    default: false,
  },
  /** 确认导入前调用，返回行级错误则阻止导入并展示在表格中 */
  serverValidate: {
    type: Function as PropType<GridImportServerValidateFn>,
  },
  beforeConfirm: {
    type: Function as PropType<
      (
        rows: Record<string, unknown>[],
        meta: GridImportValidateMeta
      ) => void | Promise<void>
    >,
  },
} as const)

export type GridImportProps = ExtractPublicPropTypes<typeof gridImportProps>
